var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 51.1 50"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M24.1 30.4h10.57a18.15 18.15 0 1 0-10.58 7.11V30.4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m26.19 14.43-7.33 8.75-4.67-6.02-1.58 1.22 6.19 7.99 8.92-10.66zM51.09 30.4h-27V50h27zm-3.78 2L38 40.28 28 32.4ZM49.1 48h-23V33.46l11.95 9.41 11.05-9.36Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 38a18 18 0 1 1 14.67-7.6h2.39A20 20 0 1 0 20 40a20.4 20.4 0 0 0 4.09-.42v-2.07A17.8 17.8 0 0 1 20 38"
})));
export default SvgCheckEmail;